<template>

  <div class="team">
  
   <section class="team-section">
       <!-- <div class="team-text-wrap">
            <h1>The Half Human Team</h1>
       </div> -->
      
       
   </section>
  </div>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
export default {
  name: 'Team',
  components: {
    HeroHeader,
  },
   mounted(){
     document.querySelector("nav").style.marginTop = 0;
     document.querySelector("nav").style.maxWidth = "100%";
      document.querySelector("nav").style.padding = "0px 20%";
       document.querySelector("nav").style.boxShadow = "none";
     document.querySelector("nav").style.borderRadius = "0px";
     document.querySelector(".navbar-item img").style.maxHeight = "3.75rem";
     document.querySelector(".navbar-item img").style.marginTop = "-12px";
     document.querySelector(".longfazers").style.marginTop = "0px";
  }
}
</script>


<style>
.team .animated-title {
    display: none;
}
å
.team-text-wrap {
   max-width: 1573px;
    top: -130px;
    margin: auto;
    position: relative;
    background-color: rgba(0, 0, 0, 0.76);
    height: 100%;
    z-index: 1;
    border-right: 20px inset rgba(53, 53, 53, 0.32941176470588235);
    border-left: 20px inset rgba(53, 53, 53, 0.32941176470588235);
}
</style>